import type { RecipeStats } from '@/services/recipe.service';

export interface RecipeKpis {
  totalRecipes: number;
  avgFoodCost: number;
  linkedItems: number;
}

// Regression: GitHub issue #283 — "Recipe list 'Avg Food Cost' and 'Linked
// Items' KPIs are computed from the current page only".
//
// The three KPI cards must reflect EVERY recipe (matching the current filters)
// and stay constant across pages. They now come from the tenant-wide
// `/recipes/stats` aggregate, never from the current 20-row page slice. This
// maps that stats response into the KPI card values; before it loads (null) we
// show zeros rather than a page-derived guess.
export function deriveRecipeKpis(stats: RecipeStats | null): RecipeKpis {
  return {
    totalRecipes: stats?.total_recipes ?? 0,
    avgFoodCost: stats?.avg_food_cost ?? 0,
    linkedItems: stats?.linked_items ?? 0,
  };
}
